import {
  Box,
  Table,
  TableBody,
  TableFooter,
  TableRow,
  TablePagination,
} from "@mui/material";
import "./pagination.scss";

interface IEvesPagination {
  count?: number;
  rowsPerPage?: number;
  page?: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
}

const EVESPagination = ({
  count = 0,
  rowsPerPage = 50,
  page = 0, // <-- MUI TablePagination expects zero-based page index
  onPageChange,
  onRowsPerPageChange,
}: IEvesPagination) => {
  return (
    <Box className="paginationContainer">
      <Table>
        <TableBody>{/* your table rows would normally go here */}</TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={count}
              page={page}
              onPageChange={onPageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={onRowsPerPageChange}
              showLastButton
              showFirstButton
              data-cy="record_count_view"
              className="paginationStyles"
            />
          </TableRow>
        </TableFooter>
      </Table>
    </Box>
  );
};

export default EVESPagination;
